import { createSlice } from '@reduxjs/toolkit';
import { getAuthorizedMenus } from './menuAction';

const initialState = {
  menus: [],
  isLoading: false,
  error: null,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    clearMenuError: (state) => {
      state.error = null;
    },
    resetMenuState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuthorizedMenus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAuthorizedMenus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.menus = action.payload;
      })
      .addCase(getAuthorizedMenus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMenuError, resetMenuState } = menuSlice.actions;
export default menuSlice.reducer;
